import "../../component/events_page/event_detail_page.css";
// import calendarImg from "../../parm_assets/";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import React, { useState } from 'react';
import acpform from "../../parm_assets/aptcc/acp_form.pdf";

const apc = "https://ik.imagekit.io/axiomhives/parm_assets/aptcc/acp_fb_ads.jpeg?updatedAt=1769929477956";
const brochure_1 = "https://ik.imagekit.io/axiomhives/parm_assets/aptcc/acp_brochure_1.jpeg?updatedAt=1769929472471";
const brochure_2 = "https://ik.imagekit.io/axiomhives/parm_assets/aptcc/acp_brochure_2.jpeg?updatedAt=1769929474701";

const EventsDetailPage = () => {

  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderImages = [brochure_1, brochure_2]; // Add your slider images here

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="explore-events-detail-section">
      <div className="explore-events-detail-content">
        
        {/* Left Column: Main Poster */}
        <div className="explore-events-detail-image">
          <Zoom>
            <img src={apc} alt="Calendar of Events" className="apc_poster" />
          </Zoom>
        </div>

        {/* Right Column: Slider and PDF */}
        <div className="explore-events-sidebar">
          
          <div className="image-slider-container">
            <h3>Event Details</h3>
            <div className="slider-wrapper-events">
              <Zoom>
              <img src={sliderImages[currentSlide]} alt="Event Highlight" className="slider-image-item" />
              </Zoom>
              <button className="slider-nav-btn" onClick={handleNext}>Next Page</button>
            </div>
          </div>

          <div className="pdf-container">
            <h4 className="register-apc-title-form"> Registration Form</h4>
            <p className="register-apc-subtitle-form" >Download registration form here and submit complete form to malaysiaarborist@gmail.com</p>
            <div className="pdf-actions">
              {/* Use a relative path or imported file for the href */}
              <a href={acpform} target="_blank" rel="noopener noreferrer" className="pdf-btn open">
                View PDF
              </a>
              <a href={acpform} download className="pdf-btn download">
                Download
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default EventsDetailPage;
